export const OWNER_NAME = "Marina Tasić Janićijević";
export const OWNER_SIGNATURE = "Tasić Janićijević";
